import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { ActivityReportFeed } from "@/components/ActivityReportFeed";

export const Route = createFileRoute("/_authenticated/activity")({
  component: ActivityPage,
  head: () => ({
    meta: [
      { title: "Фотоотчёты сообщества — TurkeyDrive" },
      {
        name: "description",
        content:
          "Живая лента фото с мероприятий и кофе-встреч резидентов TurkeyDrive в Турции.",
      },
      { property: "og:title", content: "Фотоотчёты сообщества — TurkeyDrive" },
      {
        property: "og:description",
        content: "Живая лента фото с мероприятий и кофе-встреч резидентов TurkeyDrive.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
});

function ActivityPage() {
  return (
    <div className="min-h-screen w-full max-w-full overflow-x-clip bg-white">
      <main className="mx-auto box-border w-full max-w-[1120px] space-y-6 px-5 py-8 md:px-6 md:py-12">
        <Link to="/home" className="inline-flex items-center gap-1 text-sm text-td-teal hover:underline">
          <ChevronLeft className="h-4 w-4" />
          На главную
        </Link>
        <h1 className="text-2xl font-serif text-td-dark md:text-3xl">Фотоотчёты сообщества</h1>
        <ActivityReportFeed />
        <p className="text-sm text-td-muted">
          Фото появляются здесь после мероприятий и кофе-встреч.
        </p>
      </main>
    </div>
  );
}
